import { createFileRoute, redirect } from '@tanstack/react-router';

import { medplum } from '@/config/medplum';
import { queryClient } from '@/config/queryClient';

export const Route = createFileRoute('/(unauthenticated)/sign-out')({
	beforeLoad: async () => {
		await medplum.signOut();
		queryClient.clear();

		throw redirect({ to: '/' });
	},
});
